import moment from 'moment';
import mohLogo from '../assets/moh-logo.png';

function escapeHtml(value) {
    if (value == null || value === '') return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function buildMinistryPrintHtml(options) {
    const opts = options || {};
    const title = escapeHtml(opts.title || 'مستند');
    const docRef = escapeHtml(opts.docRef || '');
    const subtitle = escapeHtml(opts.subtitle || 'منظومة إدارة المخازن والدواء');
    const buildFor = escapeHtml(opts.buildFor || 'وزارة الصحة');
    const logoUrl = escapeHtml(opts.logoUrl || mohLogo);
    const printDate = escapeHtml(moment().format('YYYY/MM/DD HH:mm'));
    const infoHtml = opts.infoHtml || '';
    const bodyHtml = opts.bodyHtml || '';
    const signaturesHtml = opts.signaturesHtml || '';
    const footerSummary = opts.footerSummary
        || `وثيقة إدارية معتمدة صادرة عن ${buildFor}؛ تُستخدم للطباعة والأرشفة وفق الإجراءات المعتمدة. لا يُعتد بالنسخ الناقصة التوقيع أو الختم.`;
    const footerMeta = opts.footerMeta || '';

    return `<!DOCTYPE html>
<html lang="ar" dir="rtl">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${title}${docRef ? ` - ${docRef}` : ''}</title>
  <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap" rel="stylesheet">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" crossorigin="anonymous" />
  <style>
    body { width:100%; margin:0; padding:0; background:#fafafa; color:#1a1a1a; font:11px "Cairo",sans-serif; -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }
    * { box-sizing:border-box; }
    .page-container { width:210mm; min-height:297mm; margin:10mm auto; border:1px solid #d3d3d3; border-radius:4px; background:#fff; box-shadow:0 0 5px rgba(0,0,0,.08); }
    .page-inner { padding:10mm; min-height:297mm; }
    .moh-header { border-bottom:3px solid #0d6b4d; padding-bottom:8px; margin-bottom:12px; }
    .moh-brand { display:flex; align-items:center; gap:12px; flex-wrap:wrap; }
    .moh-logo { height:52px; width:auto; max-width:140px; object-fit:contain; flex-shrink:0; }
    .moh-title { color:#0d6b4d; font-weight:700; font-size:18px; letter-spacing:0.02em; }
    .moh-sub { font-size:12px; color:#444; margin-top:4px; }
    .doc-title { font-size:15px; font-weight:700; margin:8px 0 4px; }
    .section-title { font-size:13px; font-weight:700; margin:10px 0 6px; }
    th, td { line-height:1.35; font-size:10px; vertical-align:middle !important; }
    .bg-gray { background-color:#b8c9c4 !important; color:#111; }
    .bg-gray-striped-1 { background-color:#eef4f2 !important; }
    .bg-gray-striped-2 { background-color:#f5f9f7 !important; }
    .print-footer { margin-top:16px; padding-top:10px; border-top:1px solid #ccc; font-size:9px; color:#555; line-height:1.6; }
    .signatures { margin-top:14px; }
    .signatures p { font-size:10px; line-height:1.6; }
    .meta-table th { width:32%; white-space:nowrap; }
    @page { size:A4; margin:0; }
    @media print {
      html, body { width:210mm; height:297mm; background:#fff; }
      .page-container { margin:0; border:none; box-shadow:none; width:100%; min-height:auto; }
    }
  </style>
</head>
<body>
  <div class="page-container">
    <div class="page-inner">
      <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
        <div class="moh-header flex-grow-1">
          <div class="moh-brand">
            <img src="${logoUrl}" alt="" class="moh-logo" width="120" height="auto" />
            <div>
              <div class="moh-title">وزارة الصحة</div>
              <div class="moh-sub">${subtitle}</div>
            </div>
          </div>
        </div>
        <div class="text-end" style="min-width:140px;">
          <div class="doc-title">${title}</div>
          <div class="small text-muted">تاريخ الطباعة: ${printDate}</div>
        </div>
      </div>

      ${infoHtml ? `<div class="row gx-3 mb-2">${infoHtml}</div>` : ''}
      ${bodyHtml}

      ${signaturesHtml ? `<div class="row signatures text-center">${signaturesHtml}</div>` : ''}

      <div class="print-footer">
        <p class="mb-1"><strong>بطاقة المستند:</strong> ${footerSummary}</p>
        ${footerMeta ? `<p class="mb-0 small">${footerMeta}</p>` : ''}
      </div>
    </div>
  </div>
</body>
</html>`;
}
